import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedMatches from './components/FeaturedMatches';
import Features from './components/Features';
import StatsSection from './components/StatsSection';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '开云体育平台',
    url: 'https://www.kaiyunsports.com',
    description: '开云体育平台是专业的在线体育竞技服务平台，覆盖足球、篮球、网球等数百种赛事，提供实时赔率、极速入金提款、全天候客服支持。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      availableLanguage: ['Chinese', 'English'],
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '开云体育平台',
    url: 'https://www.kaiyunsports.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.kaiyunsports.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '开云体育平台 - 官方正版体育竞技投注入门',
    description: '开云体育平台是专业的在线体育竞技服务平台，覆盖足球、篮球、网球等数百种赛事，提供实时赔率、极速入金提款、全天候客服支持。',
    url: 'https://www.kaiyunsports.com',
    isPartOf: { '@type': 'WebSite', name: '开云体育平台', url: 'https://www.kaiyunsports.com' },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '开云体育平台是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '开云体育平台是专业的在线体育竞技服务平台，覆盖足球、篮球、网球等数百种赛事，为用户提供实时赔率、极速入金提款和全天候客服支持。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在开云体育平台注册账号？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '访问开云体育平台官网，点击右上角"注册"按钮，填写手机号或邮箱并设置密码，完成手机验证码验证即可成功注册。',
        },
      },
      {
        '@type': 'Question',
        name: '开云体育平台支持哪些赛事？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '开云体育平台覆盖足球、篮球、网球、电子竞技、乒乓球、羽毛球等数百种体育赛事，涵盖全球各大顶级联赛和锦标赛。',
        },
      },
      {
        '@type': 'Question',
        name: '开云体育平台如何保障资金安全？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '开云体育平台采用国际顶级加密技术和多层安全防护体系，所有资金交易均通过安全通道处理，确保用户资金和个人信息安全。',
        },
      },
      {
        '@type': 'Question',
        name: '开云体育平台的客服联系方式是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '开云体育平台提供7×24小时全天候客服支持，您可以通过客服热线400-888-9999或发送邮件至service@kaiyunsports.com联系我们。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedMatches />
          <Features />
          <StatsSection />
          <LatestArticles />
        </main>
        <Footer />
      </div>
    </>
  );
}